import CoreFetch from '../core-fetch/index.vue'

export default
{
    components:
    {
        CoreFetch
    },

    props:
    {
        action:  { type: String, default:  '' },
        enctype: { type: String, default: 'form' },

        headers:  { type: Object, default: function(){ return this.headers; } }
    },

    data(){
        return {
            isFormValid: true,
            formData: null
        }
    },

    created()
    {
        this._nbRequiredInput = 0

        this._regexMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        this._regexBirthday = /[0-3][0-9]\/[0-9]{2}\/[0-9]{4}$/

        this.eventHub.$on('form:submit', this.onFormSubmit)
        this.eventHub.$on('keydown', this.onKeyDown)
    },


    mounted()
    {
        this.$inputs = this.$el.querySelectorAll('.js-input')
        this.$submit = this.$el.querySelector('.js-submit')

        for(let i = 0; i < this.$inputs.length; i++)
        {
            if(this.$inputs[i].getAttribute('data-required'))
            {
                this.$inputs[i].addEventListener('blur', this.onBlur)
                this.$inputs[i].addEventListener('input', this.onInputChange)
                this.$inputs[i].setAttribute('data-valide', false)

                this._nbRequiredInput += 1
            }
        }

        this.$submit.addEventListener('click', this.onSubmit)
    },

    destroyed()
    {
        for(let i = 0; i < this.$inputs.length; i++)
        {
            this.$inputs[i].removeEventListener('blur', this.onBlur)
            this.$inputs[i].removeEventListener('input', this.onBlur)
        }

        this.$submit.removeEventListener('click', this.onSubmit)
        this.eventHub.$off('form:submit', this.onFormSubmit)
        this.eventHub.$off('keydown', this.onKeyDown)
    },

    methods: {

        onInputChange(event)
        {
            const input = event.currentTarget

            if(input.getAttribute('data-type') && input.getAttribute('data-type') === 'birthday')
            {
                const currValue = event.currentTarget.value.replace(/\//g, '')
                const regex = /[0-9]/


                let newValue = ''

                if(regex.test(currValue))
                {
                    newValue += currValue
                }

                if(newValue.length >= 2 && !newValue.includes('/'))
                {
                    newValue = this.insert(newValue, 2, '/')
                }

                if(newValue.length >= 5)
                {
                    newValue = this.insert(newValue, 5, '/')
                }

                event.currentTarget.value = newValue
            }

            this.checkInput(input)
        },

        insert(str, index, value)
        {
            return str.substr(0, index) + value + str.substr(index)
        },

        onKeyDown(code)
        {
            if(code === 8)
            {

            }
        },

        onBlur(event)
        {
            const input = event.currentTarget

            this.checkInput(input)
        },

        checkInput(input)
        {
            if(input.type === 'email')
            {
                if(this._regexMail.test(input.value))
                {
                    this.onSuccess(input)
                }
                else
                {
                    this.onError(input)
                }
            }

            if(input.type === 'text')
            {
                if(input.getAttribute('data-type') && input.getAttribute('data-type') === 'birthday')
                {
                    if(this._regexBirthday.test(input.value))
                    {
                        this.onSuccess(input)
                    }
                    else
                    {
                        this.onError(input)
                    }
                }
                else
                {
                    if(input.value.length > 0)
                    {
                        this.onSuccess(input)
                    }
                    else
                    {
                        this.onError(input)
                    }
                }
            }

            if(input.type === 'checkbox')
            {
                if(input.checked)
                {
                    this.onSuccess(input)
                }
                else
                {
                    this.onError(input)
                }
            }
        },

        onSuccess(input)
        {
            input.setAttribute('data-valide', true)

            input.parentElement.classList.add('is-success')
            input.parentElement.classList.remove('is-error')
        },

        onError(input)
        {
            input.setAttribute('data-valide', false)

            input.parentElement.classList.remove('is-success')
            input.parentElement.classList.add('is-error')
        },


        onSubmit(event)
        {
            event.preventDefault()

            let nbValideInput = 0

            for(let i = 0; i < this.$inputs.length; i++)
            {
                this.checkInput(this.$inputs[i])
            }

            for(let i = 0; i < this.$inputs.length; i++)
            {
                if(this.$inputs[i].getAttribute('data-required') && this.$inputs[i].getAttribute('data-valide') === 'true')
                {
                    nbValideInput += 1
                }
            }


            if(nbValideInput === this._nbRequiredInput)
            {
                console.log(this.action)

                fetch(this.action, {
                    method: 'POST',
                    body: JSON.stringify(this.serialize(this.$el))
                })
                .then((response) =>
                {
                    response.json().then((data) =>
                    {
                        this.$emit('form:success')

                    })
                })
            }
        },

        serialize(form)
        {
            let field = {}
            let s = {}

            if (typeof form == 'object' && form.nodeName == "FORM")
            {
                const len = form.elements.length

                for(let i = 0; i < len; i++)
                {
                    field = form.elements[i]

                    if(field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button')
                    {
                        if(field.type === 'select-multiple')
                        {
                            for(let j = form.elements[i].options.length - 1; j >= 0; j--)
                            {
                                if(field.options[j].selected)
                                {
                                    s[field.name] = encodeURIComponent(field.options[j].value)
                                }
                            }
                        }
                        else if((field.type !== 'checkbox' && field.type !== 'radio') || field.checked)
                        {
                           s[field.name] = field.value
                        }
                    }
                }
            }

            return s
        },

        onFormSuccess(resp){
            this.$emit('form:success')
            this.$el.classList.add('is-form-success')
        },

        onFormError(err){
            console.warn('onFormError', err)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/core-form/script.js